module.exports = __webpack_public_path__ + "static/media/logo.c736e103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = 1223
// module chunks = 0